// CategoryPage.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from './../firebase/firebaseConfig';

const CategoryPage = () => {
  const { category_name } = useParams();
  const [products, setProducts] = useState([]);
  const [categoryId, setCategoryId] = useState(null);
  const decodedCategoryName = decodeURIComponent(category_name);

  useEffect(() => {
    const fetchCategoryId = async () => {
      try {
        const categoryQuery = query(collection(db, 'Categories'), where('name', '==', decodedCategoryName));
        const categorySnapshot = await getDocs(categoryQuery);
        if (!categorySnapshot.empty) {
            const categoryDoc = categorySnapshot.docs[0];
            setCategoryId(categoryDoc.id);
            console.log("Fetched category ID:", categoryDoc.id);
          } else {
            console.log("No category found with name:", decodedCategoryName);
          }
      } catch (error) {
        console.error("Error fetching category ID: ", error);
      }
    };

    fetchCategoryId();
  }, [decodedCategoryName]);


  // for fetch the products
  useEffect(() => {
    const fetchProducts = async () => {
      if (categoryId) {
        try {
          const productQuery = query(collection(db, 'Products'), where('category', '==', categoryId));
          const productSnapshot = await getDocs(productQuery);
          const productsList = productSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          setProducts(productsList);
          console.log("Fetched products:", productsList);
          
        } catch (error) {
          console.error("Error fetching products: ", error);
        }
      }
    };

    fetchProducts();
  }, [categoryId]);

  return (
    <div>
      <h1>Category: {decodedCategoryName}</h1>
      <div className="product-list">
        {products.length > 0 ? (
          products.map(product => (
            <div key={product.id} className="product-item">
              <img src={product.images[0]} alt={product.name} />
              <h2>{product.name}</h2>
              <p>{product.description}</p>
              <p>Price: ${product.price}</p>
              {/* Add other product details here */}
            </div>
          ))
        ) : (
          <p>No products found in this category.</p>
        )}
      </div>
    </div>
  );
};

export default CategoryPage;
